const scrollToTop = (el = window) => {
  el.scrollTo({ top: 0 });
};

export default scrollToTop;
